import DistantIcon from "./Distant.svg";
import TemperamentalIcon from "./Temperamental.svg";
import MeddlesomeIcon from "./Meddlesome.svg";
import TheatricalIcon from "./Theatrical.svg";
import CautiousIcon from "./Cautious.svg";
import ChaoticIcon from "./Chaotic.svg";
import ContrarianIcon from "./Contrarian.svg";
import CynicalIcon from "./Cynical.svg";
import DocileIcon from "./Docile.svg";
import EgocentricIcon from "./Egocentric.svg";
import FrivolousIcon from "./Frivolous.svg";
import InexorableIcon from "./Inexorable.svg";
import ManipulativeIcon from "./Manipulative.svg";
import PassiveAggressiveIcon from "./Passive-aggressive.svg";
import PerfectionisticIcon from "./Perfectionistic.svg";
import RecklessIcon from "./Reckless.svg";
import RigidIcon from "./Rigid.svg";
import SelfWilledIcon from "./Self-willed.svg";
import StubbornIcon from "./Stubborn.svg";
import SuspiciousIcon from "./Suspicious.svg";

export const derailmentsIcons = {
  afstandelijk: DistantIcon,
  explosief: TemperamentalIcon,
  micromanager: MeddlesomeIcon,
  theatraal: TheatricalIcon,
  egocentrisch: EgocentricIcon,
  machiavellistisch: ManipulativeIcon,
  rigoureus: RigidIcon,
  koppig: StubbornIcon,
  cynisch: CynicalIcon,
  perfectionistisch: PerfectionisticIcon,
  passiefAgressief: PassiveAggressiveIcon,
  chaotisch: ChaoticIcon,
  roekeloos: RecklessIcon,
  behoedzaam: CautiousIcon,
  lichtzinnig: FrivolousIcon,
  meedogenloos: InexorableIcon,
  paranoide: SuspiciousIcon,
  volgzaam: DocileIcon,
  anarchistisch: ContrarianIcon,
  autopiloot: SelfWilledIcon,
};
